import { render, staticRenderFns } from "./MentorGroupsTableCpt.vue?vue&type=template&id=653b6474&scoped=true&"
import script from "./MentorGroupsTableCpt.vue?vue&type=script&lang=ts&"
export * from "./MentorGroupsTableCpt.vue?vue&type=script&lang=ts&"
import style0 from "./MentorGroupsTableCpt.vue?vue&type=style&index=0&id=653b6474&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653b6474",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VIcon,VTooltip})
